import { apiFetch } from './base';
import type { ContactFormPayload } from './types';

export function submitContactForm(data: ContactFormPayload) {
  return apiFetch<{ success: boolean; message: string }>('/api/contact', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
